<div class="banner-carousel"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()"
     (touchstart)="onTouchStart($event)"
     (touchmove)="onTouchMove($event)"
     (touchend)="onTouchEnd($event)"
     (mousedown)="onMouseDown($event)"
     (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp($event)">

  <!-- Container principal do banner (viewport) -->
  <div class="banner-container" [class.is-single]="banners.length < 2">

    <!-- Track horizontal com todos os banners -->
    <div class="banner-track"
         [style.transform]="'translateX(' + (-currentIndex * slideOffset) + 'px)'">
      @for (banner of banners; track banner.id) {
        <div class="banner-slide">
          <div class="banner-background">
            <img [src]="banner.imageUrl"
                 [alt]="banner.title || 'Banner'"
                 (error)="onImageError($event)"
                 loading="lazy"
                 class="banner-image"
                 [class.disabled]="!isClickable(banner)"
                 (click)="onBannerClick(banner)">
          </div>
        </div>
      }
      @if (banners.length > 1) {
        <div class="banner-slide" aria-hidden="true">
          <div class="banner-background">
            <img [src]="banners[0].imageUrl"
                 alt=""
                 (error)="onImageError($event)"
                 loading="lazy"
                 class="banner-image"
                 [class.disabled]="!isClickable(banners[0])"
                 (click)="onBannerClick(banners[0])">
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Indicadores do carrossel -->
  @if (banners.length > 1) {
    <div class="carousel-indicators">
      @for (banner of banners; track banner.id; let i = $index) {
        <button class="indicator-dot"
                [class.active]="i === currentIndex"
                (click)="goToSlide(i)"
                [attr.aria-label]="'Ir para slide ' + (i + 1)">
        </button>
      }
    </div>
  }
</div>
